<template>
  <div>
    <list-view
      style="height:100%;"
      v-show="isFormList === true"
    />
    <editor-questionnaire-view
      v-if="isFormList === false"
    />
  </div>
</template>

<script>
import ListView from '@/views/ListView'
import EditorQuestionnaireView from '@/views/EditorQuestionnaireView'
export default {
  name: 'layout',

  data () {
    return {
      isFormList: true,
      formId: null
    }
  },

  components: {
    ListView,
    EditorQuestionnaireView
  },

  mounted () {
    window.vueBus = this.$bus

    this.$store.dispatch('getAllOfficialModels')

    this.$bus.on('openFormApp', (payload) => {
      this.isFormList = false

      this.$store.commit('setCurrentFormId', payload.formId)
    })

    this.$bus.on('showList', (payload) => {
      this.isFormList = true

      this.$store.commit('setCurrentFormId', null)
    })
  },

  beforeDestroy () {
    this.$bus.$off('openFormApp')
    this.$bus.$off('showList')
  }
}
</script>



// WEBPACK FOOTER //
// src/views/LayoutView.vue